/* eslint-disable no-unused-vars */
import { useCallback, useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { appNumberToPromote } from 'store/selectors';
import {
  generalActions,
  formErrorsCampaign_action,
  targetingPlacementsActions,
  creativesActions,
} from 'store/actions';
import { normalizeWebsiteSearch } from 'utils';

export const useFacade = (
  search,
  setSearch,
  setIsOpen,
  sortedAppListByAlphabet = [],
  isWebsite,
) => {
  const errorFlag = useSelector((state) => state.formErrorsCampaign.main);
  const selectedItem = useSelector(appNumberToPromote);
  const [choosedApp, setChoosedApp] = useState('');
  const dispatch = useDispatch();
  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  useEffect(() => {
    if (selectedItem) {
      setChoosedApp(selectedItem);
    }
  }, [selectedItem]);

  const handleClickApplyBtn = useCallback(() => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'app',
        newValue: choosedApp,
      }),
    );
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'isWebsite',
        newValue: isWebsite,
      }),
    );
    dispatch(targetingPlacementsActions.clearState());
    dispatch(formErrorsCampaign_action.resetErrors());
    dispatch(generalActions.resetCurrentCampaignObject());
    dispatch(creativesActions.resetTrackingAndCreative());
    handleClose();
  }, [choosedApp, errorFlag]);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const handleClose = useCallback(() => {
    setSearch('');
    setIsOpen(false);
    setChoosedApp(selectedItem);
  }, []);

  const faundedApps = useMemo(() => {
    if (!search && sortedAppListByAlphabet)
      return convertArray(sortedAppListByAlphabet, selectedItem);
    const normalizedSearch = isWebsite ? normalizeWebsiteSearch(search) : search;
    return sortedAppListByAlphabet?.filter((app) => {
      if (app.pba_name.toLowerCase().includes(normalizedSearch.toLowerCase())) return app;
      if (app.pba_number.toString().includes(normalizedSearch)) return app;
      if (app.pba_url1.toLowerCase().includes(normalizedSearch.toLowerCase())) return app;
      if (isWebsite && app.pba_url?.toLowerCase().includes(normalizedSearch.toLowerCase()))
        return app;
    });
  }, [search, sortedAppListByAlphabet, selectedItem, isWebsite]);

  function convertArray(arr, selectedItem) {
    const currentItem = arr?.filter((arr) => arr.pba_id === selectedItem);
    const newArr = arr?.filter((arr) => arr.pba_id !== selectedItem);
    return currentItem.concat(newArr);
  }

  const btnLabel = useMemo(() => {
    if (isWebsite) return selectedItem ? 'Change Website' : 'Choose Website';
    return selectedItem ? 'Change App' : 'Choose App';
  }, [selectedItem, isWebsite]);

  return {
    handleSearchOnChange,
    handleClearSearchValue,
    handleClose,
    faundedApps,
    choosedApp,
    setChoosedApp,
    handleClickApplyBtn,
    btnLabel,
  };
};
